import { EFilters, useFilters } from 'features/Filters';
import { formatDate } from 'shared/utils';

export const usePlannerDates = () => {
	const { getFilterValue } = useFilters();

	const selectedDate = getFilterValue(EFilters.PLANNER_DATE)
		? new Date(getFilterValue(EFilters.PLANNER_DATE) || '')
		: new Date();

	const year = selectedDate.getFullYear().toString();
	const month = selectedDate.toLocaleDateString('ru-RU', { month: '2-digit' });
	const day = selectedDate.getDate().toString();
	const date = formatDate(selectedDate, 'iso') || '';
	return { year, month, day, date, selectedDate };
};
